/** H21: one daily-activity keeper (ผู้ดูแลกิจกรรม) in every town and city. Placeholder names, TODO-polish. */
export const DAILY_NPC_TITLE = 'ผู้ดูแลกิจกรรม';
export const DAILY_NPC_SPRITE = 'stationMaster';
/** Offset (tiles) from the zone's plaza centre. */
export const DAILY_NPC_OFFSET = [5, -2] as const;

export const DAILY_NPCS: Readonly<Record<string, string>> = {
  plains: 'หลี่เจ๋อ',
  'town-b': 'ซือเหยียน',
  'town-c': 'หมิงจื่อ',
  'town-d': 'เฉินฮุ่ย',
  'city-trade': 'จางหลิน',
  'city-sea': 'เหอปั๋ว',
  'city-desert': 'ซาหรง',
  'city-snow': 'เสวียหวา',
};

/** Where the arena and ladders are (the ประลอง window, key O, works in any zone). */
export const ARENA_HINT = 'เปิดหน้าต่างประลอง (กด O) แล้วเลือกสนามประลองยุทธหรือบันไดสวรรค์/นรก';
